import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { BaseInput, Label } from '../../../../shared/FormStyles';
import { ButtonBase } from '../../../../shared/Button';

import { pickWinners } from './data/data';

const FormActions = ({
  prize,
  winnersNumber,
  setWinnersNumber,
  setWinnerPicked,
}) => {
  const { t } = useTranslation('prizes');
  const queryClient = useQueryClient();

  const { mutate: pickWinnersMutation } = useMutation(pickWinners, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getPrize']);
      queryClient.invalidateQueries(['campaignData', prize.campaignUuid]);
      setWinnerPicked(true);
    },
  });

  const handlePickWinnerClick = () => {
    const params = { prize, winnersNumber, repick: prize.status === 'picked' };

    return pickWinnersMutation(params);
  };

  return (
    <Footer>
      <div>
        <Label>{t('pickWinners.numberOfWinners')}</Label>
        <BaseInput
          name="number_of_winners"
          type="number"
          value={winnersNumber}
          min={1}
          onChange={e => {
            setWinnersNumber(Number(e.target.value));
          }}
        />
      </div>
      <PickWinnerBtn variant="containedBlue" onClick={handlePickWinnerClick}>
        {prize.status === 'finished'
          ? t('pickWinners.titleBox')
          : t('pickWinners.repickWinnersButton')}
      </PickWinnerBtn>
    </Footer>
  );
};

export default FormActions;

const Footer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
`;

const PickWinnerBtn = styled(ButtonBase)`
  background: ${themeGet('colors.primary.100')};
  margin-top: 12px;
  width: 100%;
`;
